import { Navigate } from "@tanstack/react-router";
import { BrandMark, Button } from "@teamna/ui/components/index.ts";
import { googleSignInUrl, useStaffMe } from "../lib/cc-api.ts";
import { SplashScreen } from "./root.tsx";

/**
 * Control Center sign-in: one button, Google, @teamna.app only. The API does the whole OAuth
 * exchange and sets the session cookie; this page only starts it. Someone already signed in goes
 * straight to the businesses.
 */
export function SignInScreen() {
  const me = useStaffMe();
  if (me.isLoading) return <SplashScreen label="Checking your session" />;
  if (me.data) return <Navigate to="/businesses" replace />;

  return (
    <main className="mx-auto flex min-h-dvh w-full max-w-[420px] flex-col justify-center px-5">
      <div className="mb-8 flex items-center gap-3">
        <BrandMark className="size-10" />
        <div>
          <p className="text-[20px] leading-tight font-semibold text-ink">Teamna</p>
          <p className="text-[13px] text-ink-3">Control Center</p>
        </div>
      </div>
      <h1 className="mb-2 text-[26px] leading-tight font-semibold text-ink">Sign in</h1>
      <p className="mb-6 text-[15px] text-ink-2">For the Teamna team. Use your @teamna.app Google account.</p>
      <Button size="lg" fullWidth onClick={() => window.location.assign(googleSignInUrl())}>
        Sign in with Google
      </Button>
    </main>
  );
}
